import React from "react";
import LeftPanel from "./LeftPannel";
import { useIsForgotPassword } from "../store/selectors/userSelector";

interface LayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  overFlowHidden?: boolean;
  manualNavigationBlocked?: boolean;
  alertMessageForBeforeUnload?: string;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  overFlowHidden = false,
  manualNavigationBlocked = false,
  // alertMessageForBeforeUnload = "You have unsaved changes. Are you sure you want to leave this page?",
  alertMessageForBeforeUnload = "If there are any changes, please make sure to save them before leaving this page.",
}) => {
  const isForgotPassword = useIsForgotPassword();

  return (
    <div className="h-screen w-screen flex">
      {!isForgotPassword && (
        <LeftPanel
          manualNavigationBlocked={manualNavigationBlocked}
          alertMessageForBeforeUnload={alertMessageForBeforeUnload}
        />
      )}
      <main
        className={`layout-content flex-grow ${
          overFlowHidden ? "overflow-hidden" : "overflow-auto"
        } h-screen bg-accent`}
      >
        {children}
      </main>
    </div>
  );
};

export default Layout;
